module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Standard")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("一些基础的规范")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Span")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("元素间的距离")])]), _vm._v(" "), _c('p', [_c('v-code', {
    attrs: {
      "code": _vm.gap.join(' ')
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("基本的 xsm sm md lg xlg 五档间距，UI组件和公共业务组件强制要求，具体页面设计建议遵从。")]), _vm._v(" "), _c('h2', [_vm._v("Size")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("基础尺寸，一般用于规范元素的高度，比如一个按钮的size。")])]), _vm._v(" "), _c('h3', [_vm._v("outer")]), _vm._v(" "), _c('p', [_c('v-code', {
    attrs: {
      "code": _vm.size_o.join(' ')
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("inner")]), _vm._v(" "), _c('p', [_c('v-code', {
    attrs: {
      "code": _vm.size.join(' ')
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("outer用于Bar组件，inner用于Btn form等组件。")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("尺寸相关变量在 "), _c('code', [_vm._v("/src/style/themes/size/index.styl")]), _vm._v(" 文件中修改")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f9aa12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/standard-17.vue
// module id = 643
// module chunks = 0